import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../api/api';
import axios from 'axios';
import Swal from 'sweetalert2';

const MasterLayout = ({ children }) => {
    let [sidebarActive, seSidebarActive] = useState(false);
    let [mobileMenu, setMobileMenu] = useState(false);
    const location = useLocation(); // Hook to get the current route
    const navigate = useNavigate();
    const [logoutLoading, setLogoutLoading] = useState(false);

    const handleLogout = async () => {
        // Confirm logout
        const confirmLogout = await Swal.fire({
            title: 'Are you sure?',
            text: 'You will be logged out from the system.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, logout!',
            cancelButtonText: 'Cancel'
        });

        if (!confirmLogout.isConfirmed) return;

        setLogoutLoading(true);
        try {
            const token = localStorage.getItem('token');

            // Call logout API
            await axios.post(`${API_URL}/logout`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });

            // Clear local storage
            localStorage.clear();
            sessionStorage.clear();

            // Clear axios default headers
            delete axios.defaults.headers.common['Authorization'];

            // Show success message
            Swal.fire({
                icon: 'success',
                title: 'Logged Out!',
                text: 'You have been successfully logged out.',
                timer: 2000,
                showConfirmButton: false
            });

            // Redirect to login page
            setTimeout(() => {
                navigate('/adminLogin');
            }, 1000);

        } catch (error) {
            console.error('Logout error:', error);

            // Even if API fails, still logout locally
            localStorage.clear();
            sessionStorage.clear();
            delete axios.defaults.headers.common['Authorization'];

            Swal.fire({
                icon: 'info',
                title: 'Logged Out',
                text: 'You have been logged out from the application.',
                timer: 2000,
                showConfirmButton: false
            });

            navigate('/login');
        } finally {
            setLogoutLoading(false);
        }
    };

    const handleProfileDropdownLogout = async (e) => {
        e.preventDefault();
        await handleLogout();
    };

    useEffect(() => {
        const handleDropdownClick = (event) => {
            event.preventDefault();
            const clickedLink = event.currentTarget;
            const clickedDropdown = clickedLink.closest(".dropdown");

            if (!clickedDropdown) return;

            const isActive = clickedDropdown.classList.contains("open");

            // Close all dropdowns
            const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
            allDropdowns.forEach((dropdown) => {
                dropdown.classList.remove("open");
                const submenu = dropdown.querySelector(".sidebar-submenu");
                if (submenu) {
                    submenu.style.maxHeight = "0px"; // Collapse submenu
                }
            });

            // Toggle the clicked dropdown
            if (!isActive) {
                clickedDropdown.classList.add("open");
                const submenu = clickedDropdown.querySelector(".sidebar-submenu");
                if (submenu) {
                    submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
                }
            }
        };

        // Attach click event listeners to all dropdown triggers
        const dropdownTriggers = document.querySelectorAll(
            ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
        );

        dropdownTriggers.forEach((trigger) => {
            trigger.addEventListener("click", handleDropdownClick);
        });

        const openActiveDropdown = () => {
            const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
            allDropdowns.forEach((dropdown) => {
                const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
                submenuLinks.forEach((link) => {
                    if (
                        link.getAttribute("href") === location.pathname ||
                        link.getAttribute("to") === location.pathname
                    ) {
                        dropdown.classList.add("open");
                        const submenu = dropdown.querySelector(".sidebar-submenu");
                        if (submenu) {
                            submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
                        }
                    }
                });
            });
        };

        // Open the submenu that contains the active route
        openActiveDropdown();

        // Cleanup event listeners on unmount
        return () => {
            dropdownTriggers.forEach((trigger) => {
                trigger.removeEventListener("click", handleDropdownClick);
            });
        };
    }, [location.pathname]);

    let sidebarControl = () => {
        seSidebarActive(!sidebarActive);
    };

    let mobileMenuControl = () => {
        setMobileMenu(!mobileMenu);
    };

    return (
        <section className={mobileMenu ? "overlay active" : "overlay "}>
            {/* sidebar */}
            <aside
                className={
                    sidebarActive
                        ? "sidebar active "
                        : mobileMenu
                            ? "sidebar sidebar-open"
                            : "sidebar"
                }
            >
                <button
                    onClick={mobileMenuControl}
                    type='button'
                    className='sidebar-close-btn'
                >
                    <Icon icon='radix-icons:cross-2' />
                </button>
                <div>
                    <Link to='/' className='sidebar-logo'>
                        <img
                            src='assets/images/logo.png'
                            alt='site logo'
                            className='light-logo'
                        />
                        <img
                            src='assets/images/logo-light.png'
                            alt='site logo'
                            className='dark-logo'
                        />
                        <img
                            src='assets/images/logo-icon.png'
                            alt='site logo'
                            className='logo-icon'
                        />
                    </Link>
                </div>
                <div className='sidebar-menu-area'>
                    <ul className='sidebar-menu' id='sidebar-menu'>
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon
                                    icon='solar:home-smile-angle-outline'
                                    className='menu-icon'
                                />
                                <span>Home</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/admindashboard'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                                        Summery
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/adminbankAccount'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Account
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink
                                        to='/admin-director'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Director
                                    </NavLink>
                                </li>

                            </ul>
                        </li>


                        {/* Invoice Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon icon='hugeicons:invoice-03' className='menu-icon' />
                                <span>Branch</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/managebranch'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Manage Branch
                                    </NavLink>
                                </li>
                            </ul>
                        </li>

                        <li className='sidebar-menu-group-title'>Application</li>

                        {/* Invoice Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon icon='hugeicons:invoice-03' className='menu-icon' />
                                <span>Enquiry</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manageenquiry'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Manage Enquiry
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/managefollowup'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />
                                        Follow Up
                                    </NavLink>
                                </li>
                            </ul>
                        </li>

                        {/* Ai Application Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <i className='ri-robot-2-line mr-10' />

                                <span>Employee Management</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-employee'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Manage Employee
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/manage-employee-profile'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Employee Profile
                                    </NavLink>
                                </li>


                            </ul>
                        </li>

                        {/* Crypto Currency Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <i className='ri-btc-line mr-10' />
                                <span>Customer Management</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-groups'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Manage Groups
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/manage-member-search'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />
                                        Manage Member
                                    </NavLink>
                                </li>

                            </ul>
                        </li>


                        {/* Invoice Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon icon='hugeicons:invoice-03' className='menu-icon' />
                                <span>Loan Management</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-loan-search'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Loan
                                    </NavLink>
                                </li>

                            </ul>
                        </li>

                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon icon='hugeicons:invoice-03' className='menu-icon' />
                                <span>Collaction List</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-today-coll-search'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Today Coll.
                                    </NavLink>
                                </li>
                            </ul>
                        </li>

                        {/* <li className='dropdown'>
                            <Link to='#'>
                                <Icon icon='hugeicons:invoice-03' className='menu-icon' />
                                <span>Collaction List</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-today-cash-coll'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Today Cash Coll.
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink
                                        to='/manage-today-product-coll'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Today Product Coll.
                                    </NavLink>
                                </li>
                            </ul>
                        </li> */}

                        {/* Invoice Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon icon='hugeicons:invoice-03' className='menu-icon' />
                                <span>Closed Account</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-cash-closed-account'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Cash Account
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/manage-product-closed-account'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />
                                        Product Account
                                    </NavLink>
                                </li>
                            </ul>
                        </li>

                        {/* Components Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon
                                    icon='solar:document-text-outline'
                                    className='menu-icon'
                                />
                                <span>Product</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/manage-dealer'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />
                                        Dealer
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/manage-category'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Category
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/manage-product'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-success-main w-auto' />{" "}
                                        Product
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/purchase-order'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-lilac-600 w-auto' />{" "}
                                        Purchase Order
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink
                                        to='/approved-purchase-order'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-lilac-600 w-auto' />{" "}
                                        Approved Purchase Order
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink
                                        to='/manage-store'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-lilac-600 w-auto' />{" "}
                                        Store
                                    </NavLink>
                                </li>
                            </ul>
                        </li>

                        {/* Users Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon
                                    icon='flowbite:users-group-outline'
                                    className='menu-icon'
                                />
                                <span>Users</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/users-list'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Users List
                                    </NavLink>
                                </li>

                                <li>
                                    <NavLink
                                        to='/add-user'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-info-main w-auto' />{" "}
                                        Add User
                                    </NavLink>
                                </li>

                            </ul>
                        </li>

                        {/* Role & Access Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <i className='ri-user-settings-line' />
                                <span>Role &amp; Access</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/role-access'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Role &amp; Access
                                    </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink
                                        to='/assign-role'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Assign Role
                                    </NavLink>
                                </li> */}
                            </ul>
                        </li>


                        {/* Report */}
                        {/* Settings Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon
                                    icon='icon-park-outline:setting-two'
                                    className='menu-icon'
                                />
                                <span>Report</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                <li>
                                    <NavLink
                                        to='/branch-report'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Branch
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/meeting-sheet'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Meeting Sheet
                                    </NavLink>
                                </li>
                                {/* <li>
                                    <NavLink
                                        to='/active-account'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-info-main w-auto' />{" "}
                                        Active Account
                                    </NavLink>
                                </li> */}
                                {/* <li>
                                    <NavLink
                                        to='/closed-account'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                                        Closed Account
                                    </NavLink>
                                </li> */}
                                {/* <li>
                                    <NavLink
                                        to='/groups-report'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                                        Groups
                                    </NavLink>
                                </li> */}

                                {/* <li>
                                    <NavLink
                                        to='/member-report'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                                        Member
                                    </NavLink>
                                </li> */}


                            </ul>
                        </li>
                        {/* end of report */}
                        {/* <li className='sidebar-menu-group-title'>Application</li> */}


                        {/* Settings Dropdown */}
                        <li className='dropdown'>
                            <Link to='#'>
                                <Icon
                                    icon='icon-park-outline:setting-two'
                                    className='menu-icon'
                                />
                                <span>Settings</span>
                            </Link>
                            <ul className='sidebar-submenu'>
                                {/* <li>
                                    <NavLink
                                        to='/company'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-primary-600 w-auto' />{" "}
                                        Company
                                    </NavLink>
                                </li> */}
                                {/* <li>
                                    <NavLink
                                        to='/notification'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-warning-main w-auto' />{" "}
                                        Notification
                                    </NavLink>
                                </li> */}
                                <li>
                                    <NavLink
                                        to='/login-history'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-info-main w-auto' />{" "}
                                        Login History
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/audit-history'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-info-main w-auto' />{" "}
                                        Audit Log
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/change-password'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                                        Change Password
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to='/term-condition'
                                        className={(navData) =>
                                            navData.isActive ? "active-page" : ""
                                        }
                                    >
                                        <i className='ri-circle-fill circle-icon text-danger-main w-auto' />{" "}
                                        Term & Condition
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </aside>

            <main
                className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
            >
                <div className='navbar-header'>
                    <div className='row align-items-center justify-content-between'>
                        <div className='col-auto'>
                            <div className='d-flex flex-wrap align-items-center gap-4'>

                                <button
                                    type='button'
                                    className='sidebar-toggle'
                                    onClick={sidebarControl}
                                >
                                    {sidebarActive ? (
                                        <Icon
                                            icon='iconoir:arrow-right'
                                            className='icon text-2xl non-active'
                                        />
                                    ) : (
                                        <Icon
                                            icon='heroicons:bars-3-solid'
                                            className='icon text-2xl non-active '
                                        />
                                    )}
                                </button>
                                <button
                                    onClick={mobileMenuControl}
                                    type='button'
                                    className='sidebar-mobile-toggle'
                                >
                                    <Icon icon='heroicons:bars-3-solid' className='icon' />
                                </button>
                            </div>
                        </div>
                        <div className='col-auto'>
                            <div className='d-flex flex-wrap align-items-center gap-3'>

                                {/* ThemeToggleButton */}
                                <ThemeToggleButton />
                                {/* Notification dropdown end */}
                                <button
                                    onClick={handleLogout}
                                    className='btn btn-outline-danger d-flex align-items-center gap-2'
                                    style={{ padding: '6px 12px', fontSize: '14px' }}
                                    disabled={logoutLoading}
                                >
                                    {logoutLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Logging Out...
                                        </>
                                    ) : (
                                        <>
                                            <Icon icon='lucide:power' className='icon text-lg' />
                                            Log Out
                                        </>
                                    )}
                                </button>

                                <div className='dropdown'>
                                    <button
                                        className='d-flex justify-content-center align-items-center rounded-circle'
                                        type='button'
                                        data-bs-toggle='dropdown'
                                    >
                                        <img
                                            src='assets/images/user.png'
                                            alt='image_user'
                                            className='w-40-px h-40-px object-fit-cover rounded-circle'
                                        />
                                    </button>
                                    <div className='dropdown-menu to-top dropdown-menu-sm'>
                                        <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                                            <div>
                                                <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                                                    DCTP
                                                </h6>
                                                <span className='text-secondary-light fw-medium text-sm'>
                                                    Admin
                                                </span>
                                            </div>
                                            <button type='button' className='hover-text-danger'>
                                                <Icon
                                                    icon='radix-icons:cross-1'
                                                    className='icon text-xl'
                                                />
                                            </button>
                                        </div>


                                        <ul className='to-top-list'>
                                            <li>
                                                <Link
                                                    className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                                                    to='/view-profile'
                                                >
                                                    <Icon
                                                        icon='solar:user-linear'
                                                        className='icon text-xl'
                                                    />{" "}
                                                    My Profile
                                                </Link>
                                            </li>

                                            <li>
                                                <Link
                                                    className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'
                                                    to='/change-password'
                                                >
                                                    <Icon
                                                        icon='icon-park-outline:setting-two'
                                                        className='icon text-xl'
                                                    />
                                                    Change Password
                                                </Link>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={handleProfileDropdownLogout}
                                                    className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3 w-100 border-0 bg-transparent'
                                                    style={{ textAlign: 'left' }}
                                                    disabled={logoutLoading}
                                                >
                                                    <Icon icon='lucide:power' className='icon text-xl' />{" "}
                                                    {logoutLoading ? 'Logging Out...' : 'Log Out'}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* Profile dropdown end */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* dashboard-main-body */}
                <div className='dashboard-main-body'>{children}</div>

                {/* Footer section */}
                <footer className='d-footer'>
                    <div className='row align-items-center justify-content-between'>
                        <div className='col-auto'>

                        </div>
                        <div className='col-auto'>
                            <p className='mb-0'>
                                Developed by <span className='text-primary-600'>BookYourCoder</span>
                            </p>
                        </div>
                    </div>
                </footer>
            </main>
        </section>
    );
};

export default MasterLayout;